const formatDateTime = (isoString, format = "DD/MM/YYYY hh:mm:ss A") => {
  const date = new Date(isoString);

  if (isNaN(date.getTime())) return "";

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  const hours24 = date.getHours();
  const hours12 = hours24 % 12 || 12;
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");
  const ampm = hours24 >= 12 ? "PM" : "AM";

  const formats = {
    "DD/MM/YYYY": `${day}/${month}/${year}`,
    "YYYY-MM-DD": `${year}-${month}-${day}`,
    "DD-MM-YYYY": `${day}-${month}-${year}`,
    "MM/DD/YYYY": `${month}/${day}/${year}`,

    "hh:mm A": `${String(hours12).padStart(2, "0")}:${minutes} ${ampm}`,
    "hh:mm:ss A": `${String(hours12).padStart(2, "0")}:${minutes}:${seconds} ${ampm}`,
    "HH:mm:ss": `${String(hours24).padStart(2, "0")}:${minutes}:${seconds}`,

    "DD/MM/YYYY hh:mm:ss A": `${day}/${month}/${year} ${String(hours12).padStart(2, "0")}:${minutes}:${seconds} ${ampm}`,
    "YYYY-MM-DD HH:mm:ss": `${year}-${month}-${day} ${String(hours24).padStart(2, "0")}:${minutes}:${seconds}`,
    "DD-MM-YYYY HH:mm:ss": `${day}-${month}-${year} ${String(hours24).padStart(2, "0")}:${minutes}:${seconds}`,
  };

  return formats[format] || formats["DD/MM/YYYY hh:mm:ss A"];
};

export default formatDateTime;
